import { formatDateMoment } from 'utils/utils'

export const TAB_REQUEST_AWB = ['request awb', 'print label']

export const TABLE_REQUEST_AWB = {
    name: 'Orders',
    column: [
        {
            name: 'Nomor Pesanan',
            key: 'order_code',
            render: ({ value }) => <div className={'font-medium text-blue-90'}>{value}</div>,
        },
        {
            name: 'Alamat Pengiriman',
            render: ({ item }) => (
                <div>
                    <div className={'font-medium'}>{item?.shipping_name}</div>
                    <div>{item?.shipping_address}</div>
                </div>
            ),
        },
        {
            name: '',
            render: ({ item }) => (
                <div className={'font-medium text-blue-90'}>
                    {item?.is_request_failed ? 'Gagal Request' : 'Belum Request'}
                </div>
            ),
        },
        {
            name: 'Ekspedisi',
            render: ({ item }) => (
                <div className={'flex flex-row gap-4 items-center'}>
                    <img className={'w-12'} src={item?.shipping_image_url} alt='Ekspedisi' />
                    <div>
                        <div className={'font-medium'}>{item?.shipping_service}</div>
                        <div>{item?.shipping_route}</div>
                    </div>
                </div>
            ),
        },
        {
            name: 'Grand Total',
            key: 'grand_total',
        },
        {
            name: 'Tanggal Order',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD/MM/YYYY HH:mm'),
        },
    ],
}

export const TABLE_PRINT_ORDER = {
    name: 'Orders',
    column: [
        {
            name: 'Nomor Pesanan',
            key: 'order_code',
            render: ({ value }) => <div className={'font-medium text-blue-90'}>{value}</div>,
        },
        {
            name: 'Alamat Pengiriman',
            render: ({ item }) => (
                <div>
                    <div className={'font-medium'}>{item?.shipping_name}</div>
                    <div>{item?.shipping_address}</div>
                </div>
            ),
        },
        {
            name: 'Ekspedisi',
            render: ({ item }) => (
                <div className={'flex flex-row gap-4 items-center'}>
                    <img className={'w-12'} src={item?.shipping_image_url} alt='Ekspedisi' />
                    <div>
                        <div className={'font-medium'}>{item.shipping_service}</div>
                        <div>{item.shipping_route}</div>
                    </div>
                </div>
            ),
        },
        {
            name: 'Grand Total',
            key: 'grand_total',
        },
        {
            name: 'Nomor Resi',
            key: 'awb',
            render: ({ value }) => <div className={'font-medium text-blue-90'}>{value}</div>,
        },
        {
            name: 'Tanggal Order',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD/MM/YYYY HH:mm'),
        },
    ],
}

export const FILTER_REQUEST_AWB = [
    {
        title: 'Ekspedisi',
        key: 'shipping_aliases',
        list: [],
    },
]
